import styled from 'styled-components'
import { BLACK } from '@styles/colors'
import { GIVONIC, INTER } from '@styles/fonts'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px 12px 12px 12px;
  overflow-y: auto;
`

export const ImageContainer = styled.div`
  width: 50%;
`

export const RewardImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const TitleContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 12px 0;
`

export const TitleText = styled.span`
  text-align: center;
  font-family: ${GIVONIC.bold};
  font-size: 16px;
  color: ${BLACK};
`

export const SubtitleText = styled.span`
  text-align: center;
  font-family: ${INTER.light};
  font-size: 13px;
  color: ${BLACK};
`

export const StepsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const StepsTitle = styled.span`
  font-family: ${INTER.medium};
  font-size: 13px;
`

export const StepsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`
